module.exports = __webpack_public_path__ + "static/media/pin.c74231bb.svg";